import type { BootNotificationDomain, BootNotificationResponse } from '@/protocol/OcppAdapter';

/** Domain → wire (identity passthrough for 1.6 — types align). */
export function buildBootNotificationRequest(req: BootNotificationDomain): Record<string, unknown> {
  return { ...req };
}

export function parseBootNotificationResponse(
  payload: Record<string, unknown>,
): BootNotificationResponse {
  return {
    status: payload['status'] as BootNotificationResponse['status'],
    currentTime: payload['currentTime'] as string,
    interval: payload['interval'] as number,
  };
}
